import { FaCamera, FaRegSave, FaShare } from "react-icons/fa";
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useSelector } from 'react-redux'
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux'
import getTime from 'helpers/timenow'
import { ModalWrapper } from "./styled"
import NoBody from 'assets/images/no-avatar.png'
import { staffSelector, authSelector, customerSelector } from 'redux/selector'
import ShowToast from 'utils/ShowToast'
import { staffActions } from 'redux/slice/staffSlice'
import ButtonIcon from "components/ButtonIcon";
import { customerActions } from "redux/slice/customerSlice";
import { REGEX_PHONE_NUMBER } from "constants/regex"
import { authError } from "errors/auth"
import { useRef } from "react";
import Label from "components/Label";
import Input from "components/Input";

const AdminModalEditAccount = ({ typeModal, selectedId, showModal, hidden, method, currentPage, setCurrentPage, querySearch, permission, sex }) => {
    const staffState = useSelector(staffSelector)
    const customerState = useSelector(customerSelector)
    const authState = useSelector(authSelector)
    const dispatch = useDispatch()
    const avatarRef = useRef()

    let title = ''
    if (method === 'add' && typeModal === "staff") {
        title = 'Thêm mới nhân viên'
    }
    if (method === 'show') {
        title = 'Chi tiết tài khoản'
    }
    if (method === 'update') {
        title = 'Cập nhật tài khoản'
    }
    if (method === 'remove') {
        title = 'Xóa tài khoản'
    }

    const formData = useFormik({
        initialValues: {
            id: "",
            account_name: "",
            avatar: "",
            full_name: "",
            email: "",
            phone_number: "",
            sex: 0,
            birth_day: "",
            created_at: "",
            permission: 0,
            status: 0,
        },
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object({
            account_name: Yup.string().trim().required(authError.requiredAccount).min(4, authError.invalidAccountName),
            phone_number: Yup.string().trim().required(authError.requiredPhone).matches(REGEX_PHONE_NUMBER, authError.invalidPhone),
            email: Yup.string().trim()
                .required(authError.requiredEmail)
                .email(authError.invalidEmail),
        }),
        onSubmit: (values, { setFieldError }) => {
            if (method === 'add' && typeModal === 'staff') {
                if (staffState.isFetching === false) {
                    values.password = 'Travelwithme123#'
                    delete values['avatar']
                    delete values['id']
                    delete values['birth_day']
                    delete values['created_at']
                    delete values['sex']

                    dispatch(staffActions.addStaff({ setFieldError, values, currentPage, ShowToast, querySearch, permission, hidden, handleSetDefaultForm }))
                }
            }
            if (method === 'update' && typeModal === 'staff') {
                if (staffState.isFetching === false) {
                    if (values.birth_day === '') {
                        delete values['birth_day']
                    }
                    delete values['updated_at']
                    delete values['key']
                    dispatch(staffActions.updateStaff({ setFieldError, values, currentPage, ShowToast, querySearch, permission, hidden, handleSetDefaultForm }))
                }
            }
            if (method === 'remove' && typeModal === 'staff') {
                if (staffState.isFetching === false) {

                    // eslint-disable-next-line eqeqeq
                    if (values.account_id == authState.currentUser.user.account_id) {
                        ShowToast("error", 'Tài khoản đang đăng nhập trên thiết bị này, không thể xóa!')
                    } else {
                        dispatch(staffActions.removeStaff({ id: values.account_id, ShowToast, currentPage, setCurrentPage, querySearch, permission }))
                    }
                    handleSetDefaultForm()
                    hidden()
                }
            }
            if (method === 'update' && typeModal === 'customer') {
                if (customerState.isFetching === false) {
                    const payload = {
                        account_id: values.account_id,
                        status: values.status
                    }
                    dispatch(customerActions.updateCustomer({ data: payload, sex, currentPage, querySearch, ShowToast }))
                    handleSetDefaultForm()
                    hidden()
                }
            }
            if (method === 'remove' && typeModal === 'customer') {
                if (customerState.isFetching === false) {
                    const id = values.account_id
                    dispatch(customerActions.removeCustomer({ id, ShowToast, currentPage, setCurrentPage, querySearch, sex }))
                    handleSetDefaultForm()
                    hidden()
                }
            }
        }
    })
    function handleSetDefaultForm() {
        formData.setValues({
            id: "",
            account_name: "",
            full_name: "",
            avatar: "",
            email: "",
            phone_number: "",
            sex: 0,
            birth_day: "",
            created_at: "",
            permission: 0,
            status: 0,
        })
        formData.setTouched({}, false);
        formData.setErrors({})
    }

    const handleCloseModal = () => {
        handleSetDefaultForm()
        hidden()
    }

    useEffect(() => {

        if (selectedId !== null && typeModal === 'staff') {
            const data = staffState.staffList.filter(item => item.account_id === selectedId)

            formData.setValues({
                ...data[0]
            });
        }
        if (selectedId !== null && typeModal === 'customer') {
            const data = customerState.customerList.filter(item => item.account_id === selectedId)
            formData.setValues({
                ...data[0]
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedId, showModal, staffState.staffList, typeModal])


    return (
        <ModalWrapper>
            <div className="mda">
                <div className='mda_overlay'
                    onClick={handleCloseModal}
                    style={
                        showModal ? {
                            transform: 'translateY(0%)',
                            opacity: 1
                        } : {
                            transform: 'translateY(-120%)',
                            opacity: 0
                        }
                    }
                ></div>
                <div className='mda_container p-40'
                    style={
                        showModal ? {
                            transform: 'translateY(0%)',
                            opacity: 1
                        } : {
                            transform: 'translateY(-120%)',
                            opacity: 0
                        }
                    }
                >
                    <h3 className='mda_header pb-15'>{title}</h3>
                    <form className='mda_body' onSubmit={formData.handleSubmit}>
                        <ul className='mda_body_list'>
                            <li className='mda_body_item'>
                                <div className='mda_body_item_img'>
                                    <img src={formData.values.avatar || NoBody} ref={avatarRef} onError={() => avatarRef.current.src = NoBody} alt="avatar" />
                                </div>
                            </li>
                            {
                                method !== 'add' &&
                                <li className='mda_body_item'>
                                    <div className='mda_body_item_group'>
                                        <Label className="mb-5">{typeModal === "staff" ? "Mã nhân viên:" : "Mã khách hàng"}</Label>
                                        <Input
                                            id='mda_body_input_id'
                                            placeholder='Nhập mã nhân viên...'
                                            name="account_id"
                                            readOnly={true}
                                            value={formData.values.account_id}
                                            message={formData.errors.account_id}
                                            isError={!!formData.errors.account_id}
                                            onChange={formData.handleChange}
                                        />
                                    </div>
                                </li>
                            }
                            <li className='mda_body_item'>
                                <div className='mda_body_item_group'>
                                    <Label className="mb-5">Tên tài khoản:</Label>
                                    <Input
                                        id='mda_body_input_account_name'
                                        placeholder='Nhập tên tài khoản...'
                                        name="account_name"
                                        readOnly={(method === 'show' || method === 'remove' || typeModal === 'customer') ? true : false}
                                        value={formData.values.account_name}
                                        isError={!!formData.errors.account_name}
                                        message={formData.errors.account_name}
                                        onChange={formData.handleChange}
                                    />
                                </div>
                            </li>
                            <li className='mda_body_item'>
                                <div className='mda_body_item_group'>
                                    <Label className="mb-5">Họ và tên:</Label>
                                    <Input
                                        id='mda_body_input_full_name'
                                        placeholder='Nhập họ và tên...'
                                        readOnly={(method === 'show' || method === 'remove' || typeModal === 'customer') ? true : false}
                                        name="full_name"
                                        value={formData.values.full_name ?? ""}
                                        isError={!!formData.errors.full_name}
                                        message={formData.errors.full_name}
                                        onChange={formData.handleChange}
                                    />
                                </div>
                            </li>
                            <li className='mda_body_item'>
                                <div className='mda_body_item_group'>
                                    <Label className="mb-5">Email:</Label>
                                    <Input
                                        id='mda_body_input_email'
                                        placeholder='Nhập email...'
                                        type='email'
                                        readOnly={(method === 'show' || method === 'remove' || typeModal === 'customer') ? true : false}
                                        name="email"
                                        value={formData.values.email}
                                        isError={!!formData.errors.email}
                                        message={formData.errors.email}
                                        onChange={formData.handleChange}
                                    />
                                </div>
                            </li>
                            <li className='mda_body_item'>
                                <div className='mda_body_item_group'>
                                    <Label className="mb-5">Số điện thoại:</Label>
                                    <Input
                                        id='mda_body_input_phone'
                                        placeholder='Nhập số điện thoại...'
                                        name="phone_number"
                                        readOnly={(method === 'show' || method === 'remove' || typeModal === 'customer') ? true : false}
                                        value={formData.values.phone_number}
                                        isError={!!formData.errors.phone_number}
                                        message={formData.errors.phone_number}
                                        onChange={formData.handleChange}
                                    />
                                </div>
                            </li>
                            {
                                method !== 'add' &&
                                <li className='mda_body_item'>
                                    <div className='mda_body_item_group'>
                                        <Label className="mb-5">Ngày sinh:</Label>
                                        <Input
                                            id='mda_body_input_birth_day'
                                            type='date'
                                            placeholder='Nhập ngày sinh...'
                                            name="birth_day"
                                            readOnly={(method === 'show' || method === 'remove' || typeModal === 'customer') ? true : false}
                                            value={formData.values.birth_day ?? ""}
                                            isError={!!formData.errors.birth_day}
                                            message={formData.errors.birth_day}
                                            onChange={formData.handleChange}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                method !== 'add' &&
                                <li className='mda_body_item'>
                                    <div className='mda_body_item_group'>
                                        <Label className="mb-5">Ngày hoạt động:</Label>
                                        <Input
                                            id='mda_body_input_createat'
                                            type='date'
                                            name="created_at"
                                            readOnly={true}
                                            value={formData.values.created_at}
                                            isError={!!formData.errors.created_at}
                                            message={formData.errors.created_at}
                                            onChange={formData.handleChange}
                                        />
                                    </div>
                                </li>
                            }

                            {
                                method !== "add" &&
                                <li className='mda_body_item'>
                                    <div className='mda_body_item_group'>
                                        <label
                                            className="mda_body_item_group_label"
                                            htmlFor='mda_body_input_sex'
                                        >
                                            Giới tính:
                                        </label>
                                        <input
                                            id='mda_body_input_sex_man'
                                            type='radio'
                                            name='sex'
                                            disabled={(method === 'show' || method === 'remove' || typeModal === 'customer') ? true : false}
                                            value={0}
                                            checked={formData.values.sex == 0 ? true : false}
                                            onChange={formData.handleChange}
                                        />
                                        <label
                                            className='mda_body_item_group_label-radio'
                                            htmlFor='mda_body_input_sex_man'>Nam</label>
                                        <input
                                            id='mda_body_input_sex_woman'
                                            type='radio'
                                            disabled={(method === 'show' || method === 'remove' || typeModal === 'customer') ? true : false}
                                            name='sex'
                                            value={1}
                                            checked={formData.values.sex == 1 ? true : false}
                                            onChange={formData.handleChange}
                                        />
                                        <label
                                            className='mda_body_item_group_label-radio'
                                            htmlFor='mda_body_input_sex_woman'
                                        >
                                            Nữ
                                        </label>
                                        <input
                                            id='mda_body_input_sex_other'
                                            type='radio'
                                            disabled={(method === 'show' || method === 'remove' || typeModal === 'customer') ? true : false}
                                            name='sex'
                                            value={1}
                                            checked={formData.values.sex == 2 ? true : false}
                                            onChange={formData.handleChange}
                                        />
                                        <label
                                            className='mda_body_item_group_label-radio'
                                            htmlFor='mda_body_input_sex_other'
                                        >
                                            Khác
                                        </label>
                                    </div>
                                </li>
                            }
                            {
                                typeModal === 'staff' && formData.values.account_id !== authState.currentUser.user.account_id &&
                                <li className='mda_body_item'>
                                    <div className='mda_body_item_group'>
                                        <label
                                            className="mda_body_item_group_label"
                                            htmlFor='mda_body_input_permission'
                                        >
                                            Chức vụ:
                                        </label>
                                        <input
                                            id='mda_body_input_permission_admin'
                                            type='radio'
                                            disabled={(method === 'show' || method === 'remove') ? true : false}
                                            name='permission'
                                            value={0}
                                            checked={formData.values.permission == 0 ? true : false}
                                            onChange={formData.handleChange}
                                        />
                                        <label
                                            className='mda_body_item_group_label-radio'
                                            htmlFor='mda_body_input_permission_admin'
                                        >
                                            Quản lý
                                        </label>
                                        <input
                                            id='mda_body_input_permission_staff'
                                            type='radio'
                                            name='permission'
                                            value={1}
                                            checked={formData.values.permission == 1 ? true : false}
                                            disabled={(method === 'show' || method === 'remove') ? true : false}
                                            onChange={formData.handleChange}
                                        />
                                        <label
                                            className='mda_body_item_group_label-radio'
                                            htmlFor='mda_body_input_permission_staff'
                                        >
                                            Nhân viên
                                        </label>
                                    </div>
                                </li>
                            }

                            {
                                method !== 'add' && formData.values.account_id !== authState.currentUser.user.account_id &&
                                <li className='mda_body_item'>
                                    <div className='mda_body_item_group'>
                                        <label
                                            className="mda_body_item_group_label"
                                            htmlFor='mda_body_input_status'
                                        >
                                            Hoạt động:
                                        </label>
                                        <input
                                            id='mda_body_input_status_on'
                                            type='radio'
                                            name='status'
                                            value={0}
                                            checked={formData.values.status == 0 ? true : false}
                                            disabled={(method === 'show' || method === 'remove') ? true : false}
                                            onChange={formData.handleChange}
                                        />
                                        <label
                                            className='mda_body_item_group_label-radio'
                                            htmlFor='mda_body_input_status_on'
                                        >
                                            Bật
                                        </label>
                                        <input
                                            id='mda_body_input_status_off'
                                            type='radio'
                                            name='status'
                                            value={1}
                                            checked={formData.values.status == 1 ? true : false}
                                            disabled={(method === 'show' || method === 'remove') ? true : false}
                                            onChange={formData.handleChange}
                                        />
                                        <label
                                            className='mda_body_item_group_label-radio'
                                            htmlFor='mda_body_input_status_off'
                                        >
                                            Tắt
                                        </label>
                                    </div>
                                </li>
                            }
                        </ul>
                        <div className="mda_body_control">
                            {
                                method === 'add' &&
                                <ButtonIcon
                                    classButton="action-danger-1"
                                    icon={<FaRegSave />}
                                    isNa={staffState.isFetching}
                                    type="submit"
                                >
                                    Thêm mới
                                </ButtonIcon>
                            }
                            {
                                method === 'update' &&
                                <ButtonIcon
                                    classButton="action-danger-1"
                                    icon={<FaRegSave />}
                                    isNa={staffState.isFetching}
                                    type="submit"
                                >
                                    Cập nhật
                                </ButtonIcon>
                            }

                            {
                                method === 'remove' &&
                                <ButtonIcon
                                    classButton="action-danger-1"
                                    icon={<FaRegSave />}
                                    isNa={staffState.isFetching}
                                    type="submit"
                                >
                                    Xóa

                                </ButtonIcon>

                            }
                            <ButtonIcon
                                classButton="action-primary"
                                icon={<FaShare />}
                                type="button"
                                onClick={handleCloseModal}
                            >
                                Thoát
                            </ButtonIcon>

                        </div>
                    </form>
                </div>
            </div>
        </ModalWrapper >
    );
}

export default AdminModalEditAccount;